module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Cooking/Sieve-1dd1e9f98a4453589de94eb6f165cd83.svg";